import { useState, useEffect } from 'react';
import supabase, { orgId } from '../supabaseClient';

export default function useRole(session) {
  const [role, setRole]               = useState(null);
  const [permissions, setPermissions] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    if (!session?.user) { setRoleLoading(false); return; }

    async function load() {
      const { data: roleData } = await supabase
        .from('user_roles')
        .select('role')
        .eq('org_id', orgId)
        .eq('user_id', session.user.id)
        .maybeSingle();

      const userRole = roleData?.role || 'viewer';
      setRole(userRole);

      if (userRole === 'admin') {
        setPermissions(null);
        setRoleLoading(false);
        return;
      }

      const { data: perms } = await supabase
        .from('tab_permissions')
        .select('tab_key, enabled')
        .eq('org_id', orgId)
        .eq('role', userRole);

      const permMap = {};
      (perms || []).forEach(p => { permMap[p.tab_key] = p.enabled; });
      setPermissions(permMap);
      setRoleLoading(false);
    }
    load();
  }, [session]);

  const canSee  = (tabKey) => { if (role === 'admin') return true; if (!permissions) return false; return permissions[tabKey] === true; };
  const canEdit = role === 'admin' || role === 'editor';

  return { role, permissions, roleLoading, canSee, canEdit };
}
